import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { get_data } from "../../../actions/index";
import Loading from "../loading";
import { formatDate } from "../charts/utils/DatesFormats";
import { Dropdown } from "primereact/dropdown";
import States from "../states";
import ActionDelete from "./actionDelete";
import store from "../../../reducer/store";
import ActionDashboard from "./actionDashboard";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { currentAndPreviousDate } from "../charts/utils/DatesFormats";
import "../../../css/generals/dataTable.css";
import { exportPdf, exportCSV } from "./utilsDataTableLazy";

export default function DataTableLazyDevices(props) {
  // console.log(props);
  let { user } = store.getState();
  const dt = useRef(null);
  const it = useRef(null);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [devices, setDevices] = useState(null);
  const [selectedRowsPerPage, setSelectedRowsPerPage] = useState(10);
  const [selectedFilter, setSelectedFilter] = useState("identity");
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 1,
    sortField: null,
    sortOrder: null,
    filter: "identity",
    reload: false,
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [table] = useState(props.table);
  let columns = [
    {
      field: "status_lock",
      header: "Estado"
    },
    {
      field: "name",
      header: "Nombre",
    },
    {
      field: "identity",
      header: "Identificador",
    },
    {
      field: "mac",
      header: "Mac Address",
    },
    {
      field: "IMEI",
      header: "IMEI",
    },
    {
      field: "last_date",
      header: "Última Conexión",
    },
  ];
  let groupId;
  if (props.table === "addDevices") groupId = props.groupId;

  useEffect(() => {
    loadLazyData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyParams]);

  const loadLazyData = async (props) => {
    let response;
    setLoading(true);
    if (props) {
      setLazyParams({
        ...lazyParams,
        reload: props,
      });
    }

    let sortField = lazyParams.sortField;
    let sortOrder = lazyParams.sortOrder;

    let json = {
      like:
        globalFilterValue === "" || it.current.value === ""
          ? null
          : lazyParams.filter === "identity" || lazyParams.filter === undefined
          ? globalFilterValue
          : globalFilterValue,
      offset: lazyParams.first,
      limit: lazyParams.rows,
      order:
        sortField === null || sortOrder === null
          ? ["last_date", "DESC"]
          : sortOrder === 1
          ? [sortField, "ASC"]
          : [sortField, "DESC"],
      column: lazyParams.filter === undefined ? "identity" : lazyParams.filter,
    };

    if (table === "reports") {
      let date = currentAndPreviousDate(6, "-");
      let day = new Date(date[1]).toISOString().split("T")[0];
      json.include = day + " 00:00:00.000 +00:00";
      response = await get_data("reports", JSON.stringify(json));
    } else {
      response = await get_data("devices", JSON.stringify(json));
    }

    if (response.data?.error && response.data?.error === true) {
      setDevices([]);
      setLoading(false);
    } else {
      let data = response.data.rows;

      if (groupId) {
        data.forEach((device) => {
          let answer;
          answer = device.groups.findIndex(
            (group) => group.id === parseInt(groupId)
          );
          if (answer === -1) {
            device.is_selectable = true;
          } else {
            device.is_selectable = false;
          }
        });
      }

      if (data && data.length === 0) {
        setDevices([]);
      } else if (data && data.length !== 0) {
        data.forEach((info) => {
          if (info.last_date === null) {
            info.last_date = "10-01-2023 10:23:00";
          } else {
            info.last_date = formatDate(info.last_date);
          }

          if(info.status_lock === true){
            info.status_lock = 'Bloqueado'
          } else {
            info.status_lock = 'Activo'
          }
        });
        setDevices(data);
      }
      setTotalRecords(response.data?.count);
      setLoading(false);

      if (props) {
        setLazyParams({
          ...lazyParams,
          reload: false,
        });
      }
    }
  };

  const isSelectable = (data) => data.is_selectable !== false;

  const isRowSelectable = (event) =>
    event.data ? isSelectable(event.data) : true;

  const rowClassName = (data) => (isSelectable(data) ? "" : "p-disabled");

  const onPage = (event) => {
    setLazyParams({
      ...lazyParams,
      page: event.page,
      first: event.first,
    });
  };

  const onSort = (event) => {
    setLazyParams({
      ...lazyParams,
      sortField: event.sortField,
      sortOrder: event.sortOrder,
    });
  };

  const onSelectionChange = (event) => {
    if (event.value) {
      if (props?.table !== "addDevices") props.onSelecteds(event.value);
      else props.onSelecteds(event.value, props.table);
    } else {
      if (props?.table === "addDevices") props.onSelecteds(event, props.table);
      else props.onSelecteds(event);
    }
  };

  const onGlobalFilter = (e) => {
    loadLazyData();
  };

  const onChangeFilterInput = (e) => {
    setGlobalFilterValue(e.target.value);

    if (e.target.value === "") {
      setTimeout(() => {
        loadLazyData();
      }, 1500);
    }
  };

  const onKeyUpInputText = (e) => {
    if (e.key === "Enter") {
      loadLazyData();
    }
  };

  const onFilters = (e) => {
    setSelectedFilter(e.value);
    setLazyParams({
      ...lazyParams,
      filter: e.value,
    });
  };

  const renderHeader = () => {
    const dropdownOptions = [
      { label: "Nombre", value: "name" },
      { label: "Identificador", value: "identity" },
      { label: "Mac Address", value: "mac" },
      { label: "IMEI", value: "IMEI" },
    ];

    return (
      <div className="containerHeader">
        {user.range === 3 ? null : (
          <div className="containerButtons">
            <div className="buttonExtract">
              <Button
                type="button"
                icon="pi pi-file"
                onClick={() =>
                  exportCSV(
                    props?.table === "reports" ? props?.dateQuery : undefined
                  )
                }
                className="mr-2"
                data-pr-tooltip="CSV"
              />
              <Button
                type="button"
                icon="pi pi-file-pdf"
                onClick={() =>
                  exportPdf(
                    props?.table === "reports" ? props?.dateQuery : undefined
                  )
                }
                className="p-button-success mr-2"
                data-pr-tooltip="PDF"
              />
            </div>
            {props?.table !== "reports" ? (
              <Button
                type="button"
                onClick={() => onSelectionChange([])}
                className="p-button-success mr-2 uncheck"
              >
                Limpiar selección
              </Button>
            ) : null}
          </div>
        )}
        {props?.table !== "reports" ? (
          <div
            className="searchContainer"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "0.5rem",
            }}
          >
            <span className="p-input-icon-left">
              <i className="pi pi-search search" onClick={onGlobalFilter} />
              <InputText
                value={globalFilterValue}
                onChange={onChangeFilterInput}
                placeholder="Buscar..."
                ref={it}
                onKeyUp={onKeyUpInputText}
              />
            </span>
            <Dropdown
              value={selectedFilter}
              options={dropdownOptions}
              onChange={onFilters}
              optionLabel="label"
              optionValue="value"
              className="filterDropdown"
            />
          </div>
        ) : null}
      </div>
    );
  };

  let tableHeader = renderHeader();

  const states = (rowData) => {
    return (
      <States
        alert={rowData.stat}
        title={rowData.status_lock}
      ></States>
    );
  };

  const deleted = (rowData) => {
    return (
      <ActionDelete
        id={rowData.id}
        table={props?.table}
        reload={loadLazyData}
      ></ActionDelete>
    );
  };

  const dashboard = (rowData) => {
    return (
      <ActionDashboard
        type={props?.table === "devices" ? "device" : "group"}
        id={rowData.id}
        data={rowData}
      ></ActionDashboard>
    );
  };

  let rowsPerPageDropdown = () => {
    const dropdownOptions = [
      { label: "5", value: 5 },
      { label: "10", value: 10 },
      { label: "20", value: 20 },
    ];

    const onRowsPerPageChange = (e) => {
      setSelectedRowsPerPage(e.value);
      setLazyParams({
        ...lazyParams,
        rows: e.value,
      });
    };

    return (
      <div className="footerDataTable">
        <span
          className="mx-1"
          style={{ color: "var(--text-color)", userSelect: "none" }}
        >
          Dispositivos por página:
        </span>
        <Dropdown
          value={selectedRowsPerPage}
          options={dropdownOptions}
          onChange={onRowsPerPageChange}
          optionLabel="label"
          optionValue="value"
          className="rowsDropdown"
        />
        <p style={{ marginBottom: "0", fontWeight: "normal" }}>
          {lazyParams.rows > devices.length
            ? `Mostrando ${devices.length} de ${totalRecords}`
            : `Mostrando ${lazyParams.first + 1} a ${
                lazyParams.first + selectedRowsPerPage
              } de ${totalRecords}`}
        </p>
      </div>
    );
  };

  if (devices === null) {
    return (
      <div>
        <Loading color="primary" />;
      </div>
    );
  } else {
    return (
      <div className="datatable-doc-demo">
        <DataTable
          size="large"
          className="p-datatable-customers"
          ref={dt}
          value={devices}
          lazy
          dataKey="id"
          paginator
          onPage={onPage}
          onSort={onSort}
          sortField={lazyParams.sortField}
          sortOrder={lazyParams.sortOrder}
          rows={lazyParams.rows}
          first={lazyParams.first}
          responsiveLayout="scroll"
          totalRecords={totalRecords}
          loading={loading}
          emptyMessage="No existen datos para mostrar."
          selection={props?.selectedRows}
          onSelectionChange={onSelectionChange}
          header={tableHeader}
          footer={rowsPerPageDropdown}
          isDataSelectable={isRowSelectable}
          rowClassName={rowClassName}
        >
          {props?.table !== "reports" ? (
            <Column
              selectionMode="multiple"
              headerClassName="selectionChexbox"
            />
          ) : null}

          {props?.table !== "reports" ? (
            <Column
              header="Dispositivo"
              bodyStyle={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                overflow: "visible",
                justifyContent: "center",
              }}
              style={{ minWidth: "10rem", height: "5.5rem" }}
              body={states}
            />
          ) : null}

          {columns.map((column) => {
            return (
              <Column
                field={column.field}
                header={column.header}
                sortable
                style={{ textAlign: "center" }}
              />
            );
          })}

          {user.range === 1 && props?.table !== "reports" ? (
            <Column
              headerStyle={{
                width: "4rem",
                textAlign: "center",
              }}
              bodyStyle={{
                textAlign: "center",
                overflow: "visible",
              }}
              style={{ height: "5.5rem" }}
              body={dashboard}
            />
          ) : null}

          {user.range === 1 && props?.table !== "reports" ? (
            <Column
              bodyStyle={{
                textAlign: "center",
                overflow: "visible",
              }}
              body={deleted}
            />
          ) : null}
        </DataTable>
      </div>
    );
  }
}
